import './App.css';
import Countdown from 'react-countdown';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Manila');

function App() {

  const thisYear = moment().tz('Asia/Manila').year();

  const birthdays = {
    kit: {
      birthdate: '1990-01-17',
      birthday: '01-17',
      age: moment().diff(moment('1990-01-17'),'year'),
      emoji: '🥷'
    },
    rox: {
      birthdate: '1990-10-07',
      birthday: '10-07',
      age: moment().diff(moment('1990-10-07'),'year'),
      emoji: '👸🏻'
    },
    rianne: {
      birthdate: '2012-04-07',
      birthday: '04-07',
      age: moment().diff(moment('2012-04-07'),'year'),
      emoji: '🦍💨'
    },
    annibel: {
      birthdate: '2013-07-26',
      birthday: '07-26',
      age: moment().diff(moment('2013-07-26'),'year'),
      emoji: '🏎️'
    },
    dc: {
      birthdate: '2015-07-08',
      birthday: '07-08',
      age: moment().diff(moment('2015-07-08'),'year'),
      emoji: '👾'
    },
    lolo: {
      birthdate: '1966-10-19',
      birthday: '10-19',
      age: moment().diff(moment('1966-10-19'),'year'),
      emoji: '👮‍♂️'
    },
    lola: {
      birthdate: '1966-11-30',
      birthday: '11-30',
      age: moment().diff(moment('1966-11-30'),'year'),
      emoji: '🎰'
    },

    derik: {
      birthdate: '1986-07-16',
      birthday: '07-16',
      age: moment().diff(moment('1986-07-16'),'year'),
      emoji: '🚲'
    },

    tisoy: {
      birthdate: '1994-04-23',
      birthday: '04-23',
      age: moment().diff(moment('1994-04-23'),'year'),
      emoji: '🕹️'
    },

    al: {
      birthdate: '1998-09-17',
      birthday: '09-17',
      age: moment().diff(moment('1998-09-17'),'year'),
      emoji: '🍣'
    },
    kat: {
      birthdate: '1987-09-26',
      birthday: '09-26',
      age: moment().diff(moment('1987-09-26'),'year'),
      emoji: '💜'
    },
    micah: {
      birthdate: '1999-07-17',
      birthday: '07-17',
      age: moment().diff(moment('1999-07-17'),'year'),
      emoji: '🍝'
    },
    zo: {
      birthdate: '2014-11-06',
      birthday: '11-06',
      age: moment().diff(moment('2014-11-06'),'year'),
      emoji: '🦄'
    },
    kaielle: {
      birthdate: '2009-01-14',
      birthday: '01-14',
      age: moment().diff(moment('2009-01-14'),'year'),
      emoji: '📸'
    },
    kalel: {
      birthdate: '2017-11-24',
      birthday: '11-24',
      age: moment().diff(moment('2017-11-24'),'year'),
      emoji: 'ᯅ'
    },
    yoel: {
      birthdate: '2023-09-11',
      birthday: '09-11',
      age: moment().diff(moment('2023-09-11'),'year'),
      emoji: '🚜'
    }
  }

  const nextBirthday = (person) => {

    person = person.toLowerCase();

    const next = moment(thisYear+'-'+birthdays[person].birthday).tz('Asia/Manila');

    if (moment().tz('Asia/Manila').isAfter(next)) {
      return next.add(1, 'year').format('YYYY-MM-DD');
    }

    return next.tz('Asia/Manila').format('YYYY-MM-DD');
  }

  const ordinal_suffix_of = (i) => {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
  }

  const BirthdayBox = ({ person, index }) => {

    const personKey = person.toLowerCase();
    const isToday = moment().tz('Asia/Manila').format('YYYY-MM-DD') === moment(thisYear+'-'+birthdays[personKey].birthday).tz('Asia/Manila').format('YYYY-MM-DD');
    const birthdayDate = moment(birthdays[personKey].birthdate).format('MMMM D, YYYY');
    const animationDelay = `${(index + 1) * 0.05}s`;

    return (
      <div 
        className={`birthday-box relative overflow-hidden bg-white rounded-2xl p-4 text-center shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
          isToday ? 'bg-gradient-to-br from-pink-400 to-red-400 text-white animate-pulse-slow' : ''
        }`}
        style={{ animation: `fadeInUp 0.6s ease-out ${animationDelay} backwards` }}
      >
        <div className='flex justify-between'>
          <div className='flex items-center gap-2'>
            <span className="text-3xl mb-2 block">{birthdays[personKey].emoji}</span>
            <div className={`text-lg font-semibold mb-1 ${isToday ? 'text-white' : 'text-gray-800'}`}>
              {person}
            </div>
          </div>
          <div>
            {
              !isToday ? (
                <>
                  <div>
                    <Countdown 
                      date={nextBirthday(personKey)}
                      renderer={props => (
                        <div className='flex items-center gap-2'>
                          <div className="text-2xl font-bold text-indigo-600 my-2">{props.days}</div>
                          <div className="text-xs text-gray-500 uppercase tracking-wide">days until birthday</div>
                        </div>
                      )}
                    />
                  </div>
                </>
              ) : (
                <div>
                  <h3 className="text-2xl font-bold text-stone-600 my-2">🎉 TODAY! 🎉</h3>
                  <div className="text-sm text-stone/95 font-medium">
                    Happy {ordinal_suffix_of(birthdays[personKey].age)} Birthday!
                  </div>
                </div>
              )
            }
          </div>
        </div>
        { !isToday &&
          <div className="text-sm text-gray-600 mt-4">
            Turning {(birthdays[personKey].age + 1)}
          </div>
        }
        <div className={`inline-block mt-4 px-3 py-1 rounded-full text-sm ${
          isToday ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-600'
        }`}>
          {birthdayDate}
        </div>
      </div>
    );
  }

  const getDaysUntilBirthday = (person) => {
    const personKey = person.toLowerCase();
    const next = moment(thisYear+'-'+birthdays[personKey].birthday).tz('Asia/Manila');
    
    if (moment().tz('Asia/Manila').isAfter(next)) {
      next.add(1, 'year');
    }
    
    return next.diff(moment().tz('Asia/Manila'), 'days');
  }

  const familyMembers = ["Kit", "Rox", "Rianne", "Annibel", "DC", "Lolo", "Lola", "Derik", "Tisoy", "Al", "Kat", "Micah", "Zo", "Kaielle", "Kalel", "Yoel"];
  
  const sortedFamilyMembers = [...familyMembers].sort((a, b) => {
    return getDaysUntilBirthday(a) - getDaysUntilBirthday(b);
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 py-10 px-5">
      <div className="text-center text-white mb-12 animate-fade-in-down">
        <h1 className="text-5xl md:text-6xl font-bold mb-2.5 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.2)]">
          🎈 Family Birthdays 🎉
        </h1>
        <p className="text-xl opacity-90">Never miss a special day!</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {sortedFamilyMembers.map((person, index) => (
          <BirthdayBox key={person} person={person} index={index} />
        ))}
      </div>
    </div>
  );
}

export default App;
